import React from "react";

export default function CandidateOverview() {
  return <div>CandidateOverview</div>;
}
